/**
 * Localization messages for RuleConditions component
 */
import sharedMessages from '../../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../../utils/localization';

const componentMessages = {
  // Component-specific messages can be added here if needed
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export type RuleConditionsMessage = keyof typeof invertedMessages;

export default invertedMessages;
